import TextField from '@material-ui/core/TextField';
import { Collapse, Grid, MenuItem } from '@mui/material';
import * as React from 'react';

import { useWebhookContext } from '../context';
import useStyles from '../styles';

function Filter() {
  const classes = useStyles();
  const { expanded, filter, setFilter } = useWebhookContext();
  const isCollapseExpanded = expanded !== -1;

  return (
    <Collapse in={!isCollapseExpanded}>
      <Grid container spacing={2} justifyContent='flex-end' className={classes.filter}>
        <Grid item xs={12} md={4}>
          <TextField
            style={{ marginTop: 24 }}
            placeholder='Pesquisar por url ou nome'
            id='url_webhook'
            fullWidth
            onChange={(e) => setFilter({ ...filter, ...{ url: e.target.value } })}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            label='Status'
            select
            id='status'
            fullWidth
            value={filter.status}
            onChange={(e) => setFilter({ ...filter, ...{ status: e.target.value } })}
          >
            <MenuItem value={'all'}>Todos</MenuItem>
            <MenuItem value={'active'}>Ativo</MenuItem>
            <MenuItem value={'inactive'}>Inativo</MenuItem>
            <MenuItem value={'failing'}>Com erro</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            label='Tipo'
            select
            id='type'
            fullWidth
            value={filter.type}
            size='small'
            onChange={(e) => setFilter({ ...filter, ...{ type: e.target.value } })}
          >
            <MenuItem value={'all'}>Todos</MenuItem>
            <MenuItem value={'invoice'}>Fatura</MenuItem>
            {/* <MenuItem value={'contract'}>Contrato</MenuItem> */}
            <MenuItem value={'abandonment'}>Abandono de Carrinho</MenuItem>
          </TextField>
        </Grid>
      </Grid>
    </Collapse>
  );
}

export { Filter };
